module.exports = __webpack_public_path__ + "static/manual-lymphatic-drainage-west-Loop-210735f76706a9c6104f63b4bea9cb3a.webp";